export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const GET_USERS = "GET_USERS";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const CLEAR_USER = "CLEAR_USER";
export const USER_UPDATED = "USER_UPDATED";
export const CLEAR_FILTER = "CLEAR_FILTER";

export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMERS = "GET_CUSTOMERS";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const SET_CURRENT_CUSTOMER = "SET_CURRENT_CUSTOMER";
export const CLEAR_CUSTOMER = "CLEAR_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const CUSTOMER_ERROR = "CUSTOMER_ERROR";
export const FILTER_CUSTOMER = "FILTER_CUSTOMER";

export const GET_GRN = "GET_GRN";
export const GET_GRNS = "GET_GRNS";
export const ADD_GRN = "ADD_GRN";
export const UPDATE_GRN = "UPDATE_GRN";
export const SET_CURRENT_GRN = "SET_CURRENT_GRN";
export const CLEAR_GRN = "CLEAR_GRN";
export const DELETE_GRN = "DELETE_GRN";
export const GRN_ERROR = "GRN_ERROR";
export const FILTER_GRN = "FILTER_GRN";

export const GET_ASN = "GET_ASN";
export const GET_ASNS = "GET_ASNS";
export const GET_FOR_RECEIVE = "GET_FOR_RECEIVE";
export const GET_FOR_MR_TRANSIT = "GET_FOR_MR_TRANSIT";
export const GET_FOR_DD_TRANSIT = "GET_FOR_DD_TRANSIT";
export const GET_FOR_DD_DO = "GET_FOR_DD_DO";
export const ADD_ASN = "ADD_ASN";
export const UPDATE_ASN = "UPDATE_ASN";
export const SET_CURRENT_ASN = "SET_CURRENT_ASN";
export const CLEAR_ASN = "CLEAR_ASN";
export const DELETE_ASN = "DELETE_ASN";
export const ASN_ERROR = "ASN_ERROR";
export const FILTER_ASN = "FILTER_ASN";

export const GET_FEEDBACKS = "GET_FEEDBACKS";
export const ADD_FEEDBACK = "ADD_FEEDBACK";
export const FEEDBACK_ERROR = "FEEDBACK_ERROR";
